import React, { Component } from "react";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import { Tooltip, TextField, MenuItem } from "@mui/material";
import { NumericFormat } from "react-number-format";
import { clientname, currentTenant, logo, thousandsdisplay, userid } from "../../Common/Credentials";
import InventoryService from "../InventoryService";
import { inventoryid } from "../../Common/Permissions";
import { spin } from "../../Common/NewLoader";
import Menu from "../../Component/Menu";
import Header from "../../Component/Header";
import Footer from "../../Component/Footer";
import Swal from "sweetalert2";
import moment from "moment";

// Import CSS
import '../../NewUI/NewUI.css';

// Import icons
import EditIcon from "../../images/Icons/edit.png";
import CheckIcon from "../../images/Icons/check.png";
import DeleteIcon from "../../images/Icons/delete.png";
import UpArrow from "../../images/Icons/up-arrow.png";

const TabButton = ({ active, onClick, children, count }) => (
  <fieldset
    onClick={onClick}
    className={`UI-tab-button ${active ? "UI-active-tab" : "UI-inactive-tab"}`}
    style={{
      cursor: "pointer",
      transition: "all 0.3s ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px",
      padding: "8px 16px",
      fontSize: "0.8rem",
      fontWeight: 500,
      textWrap: "nowrap",
    }}
  >
    {children}
    {count > 0 && (
      <span className="UI-tab-count">{count}</span>
    )}
    <img
      src={UpArrow}
      alt="Up Arrow"
      className="UI-tab-arrow"
      style={{
        transform: active ? "rotate(30deg)" : "rotate(0deg)",
      }}
    />
  </fieldset>
);

class DamageTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      completed: [],
      cancelled: [],
      loading: false,
      activeTab: 'active',
      message: "",
      hovered: null,
      hoveredRow: null,
      isActionHovered: null,
      searchTerm: "",
      showSearch: false,
      isMobile: window.innerWidth <= 768,
      currentPage: 1,
      itemsPerPage: 20,
      sortConfig: { key: 'itemname', direction: 'asc' },
      filteredActiveData: [],
      filteredCompletedData: [],
    };
    this.refreshItems = this.refreshItems.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.sortData = this.sortData.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleItemsPerPageChange = this.handleItemsPerPageChange.bind(this);
  }

  // Sort indicator component
  SortIndicator = ({ columnKey }) => {
    if (this.state.sortConfig.key !== columnKey) {
      return <i className="fa fa-sort UI-sort-icon" />;
    }
    return this.state.sortConfig.direction === 'asc'
      ? <i className="fa fa-sort-up UI-sort-icon UI-sort-active" />
      : <i className="fa fa-sort-down UI-sort-icon UI-sort-active" />;
  }

  // Sorting function
  sortData(key) {
    let direction = 'asc';
    if (this.state.sortConfig.key === key && this.state.sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    this.setState({ sortConfig: { key, direction } });
  }

  getSortedData(data) {
    if (!this.state.sortConfig.key) return data;

    return [...data].sort((a, b) => {
      let aValue, bValue;

      switch (this.state.sortConfig.key) {
        case 'itemname':
          aValue = a.itemname || '';
          bValue = b.itemname || '';
          break;
        case 'category':
          aValue = a.category || '';
          bValue = b.category || '';
          break;
        case 'quantity':
          aValue = Number(a.quantity) || 0;
          bValue = Number(b.quantity) || 0;
          break;
        case 'price':
          aValue = Number(a.price) || 0;
          bValue = Number(b.price) || 0;
          break;
        case 'totalloss':
          aValue = Number(a.totalloss) || 0;
          bValue = Number(b.totalloss) || 0;
          break;
        case 'createdAt':
          aValue = new Date(a.createdAt).getTime();
          bValue = new Date(b.createdAt).getTime();
          break;
        default:
          aValue = a[this.state.sortConfig.key] || '';
          bValue = b[this.state.sortConfig.key] || '';
      }

      if (aValue < bValue) {
        return this.state.sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return this.state.sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  escapeRegex(string) {
    if (!string) return '';
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlightSearchText(text, searchTerm) {
    if (!searchTerm?.trim() || !text) return text;

    const rawText = String(text);
    const escapedSearchTerm = this.escapeRegex(searchTerm);

    if (escapedSearchTerm.length > 50) {
      return rawText;
    }

    try {
      const regex = new RegExp(`(${escapedSearchTerm})`, 'gi');
      const parts = rawText.split(regex);

      return parts.map((part, index) =>
        regex.test(part)
          ? React.createElement('mark', {
            key: index,
            className: 'UI-search-highlight'
          }, part)
          : part
      );
    } catch (error) {
      console.warn('Regex error in search:', error);
      return rawText;
    }
  }

  handleResize() {
    const isMobile = window.innerWidth <= 768;
    this.setState({ isMobile });
    if (!isMobile) {
      this.setState({ showSearch: false });
    }
  }

  Approve = (id) => {
    Swal.fire({
      title: "Approve Losses?",
      text: "Once approved quantity cannot be reverted back.",
      icon: "question",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonColor: "#152f5f",
      confirmButtonText: "Approve",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        InventoryService.ApproveLosses(id)
          .then(() => this.refreshItems())
          .catch((err) => err)
      }
    })
  }

  delete = (id) => {
    let data = {
      id: id,
      updatedby: userid
    }
    InventoryService.DeleteLossesentery(data)
      .then(() => this.refreshItems())
      .catch((err) => err)
  }

  refreshItems() {
    InventoryService.getDamageData(currentTenant).then((response) => {
      const activeItems = response.data.filter(e => e.status === "Pending" || e.status === "Approved")
        .sort((a, b) => a.date < b.date ? 1 : -1);
      const completedItems = response.data.filter(e => e.status === "Completed")
        .sort((a, b) => a.date < b.date ? 1 : -1);

      this.setState({
        items: activeItems,
        completed: completedItems,
        loading: false,
        filteredActiveData: activeItems,
        filteredCompletedData: completedItems
      });
    })
      .catch((e) => {
        if (e.response?.data?.error === "Unauthorized") {
          Swal.fire({
            title: "Your Session is Lost: Please login Back to resume",
            text: ".",
            icon: "error",
            confirmButtonText: "Ok",
            confirmButtonColor: "#152f5f",
          }).then(() => this.props.navigate(`/`));
        }
      })
  }

  componentDidMount() {
    if (window.innerWidth <= 768) {
      this.setState({ showSearch: true });
    }
    window.addEventListener('resize', this.handleResize);

    if (userid === undefined) {
      window.confirm('Your Session is Lost: Please login Back to resume')
      this.props.navigate(`/`)
    }
    this.setState({ loading: true })
    this.refreshItems();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleSearch(term) {
    this.setState({ searchTerm: term }, () => {
      this.updateFilteredData();
    });
  }

  updateFilteredData() {
    const { searchTerm, items, completed } = this.state;

    const filterData = (data) => {
      if (!searchTerm.trim()) return data;

      const cleanSearch = searchTerm.replace(/[^\w₹$€]/g, '').toLowerCase();

      return data.filter((item) => {
        const checkFields = [
          item.itemname,
          item.category,
          item.whname,
          item.batchid,
          item.quantity?.toString(),
          item.price?.toString(),
          item.totalloss?.toString(),
          item.comment,
          item.status,
        ];

        return checkFields.some((field) => {
          if (field === undefined || field === null) return false;

          const raw = String(field);
          const cleanField = raw.replace(/[^\w₹$€]/g, '').toLowerCase();

          return (
            cleanField.includes(cleanSearch) ||
            raw.toLowerCase().includes(searchTerm.toLowerCase())
          );
        });
      });
    };

    this.setState({
      filteredActiveData: filterData(items),
      filteredCompletedData: filterData(completed),
      currentPage: 1,
    });
  }

  getCurrentData() {
    const { activeTab, filteredActiveData, filteredCompletedData } = this.state;
    return activeTab === 'active' ? filteredActiveData : filteredCompletedData;
  }

  getCurrentPageData() {
    const currentData = this.getCurrentData();
    const { currentPage, itemsPerPage } = this.state;
    const sortedData = this.getSortedData(currentData);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return sortedData.slice(indexOfFirstItem, indexOfLastItem);
  }

  handlePageChange(newPage) {
    this.setState({ currentPage: newPage });
  }

  handleItemsPerPageChange(e) {
    this.setState({
      itemsPerPage: parseInt(e.target.value),
      currentPage: 1
    });
  }

  renderTabs() {
    const { activeTab, filteredActiveData, filteredCompletedData } = this.state;

    const tabs = [
      { key: 'active', label: 'Active', count: filteredActiveData.length },
      { key: 'completed', label: 'Completed', count: filteredCompletedData.length },
    ];

    return (
      <div className="UI-quotation-tabs-container">
        {tabs.map((tab) => (
          <div
            key={tab.key}
            className={`UI-quotation-tab ${activeTab === tab.key ? 'UI-quotation-active-tab' : ''
              } ${this.state.hovered === `${tab.key}-tab`
                ? 'UI-quotation-tab-hovered'
                : ''
              }`}
            onClick={() => this.setState({
              activeTab: tab.key,
              currentPage: 1,
              sortConfig: { key: 'itemname', direction: 'asc' }
            })}
            onMouseEnter={() => this.setState({ hovered: `${tab.key}-tab` })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {tab.label}
            {tab.count > 0 && (
              <span className="UI-match-count">{tab.count}</span>
            )}
          </div>
        ))}
      </div>
    );
  }

  renderPagination() {
    const { currentPage, itemsPerPage, isMobile } = this.state;
    const currentData = this.getCurrentData();

    if (currentData.length <= itemsPerPage) return null;

    const totalPages = Math.ceil(currentData.length / itemsPerPage);

    return (
      <div className={`UI-pagination-container ${isMobile ? 'UI-pagination-container-mobile' : ''}`}>
        <div className={`UI-pagination-info ${isMobile ? 'UI-pagination-info-mobile' : ''}`}>
          Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, currentData.length)} of {currentData.length} losses
        </div>
        <div className={`UI-pagination-controls ${isMobile ? 'UI-pagination-controls-mobile' : ''}`}>
          <TextField
            select
            value={itemsPerPage}
            onChange={this.handleItemsPerPageChange}
            variant="outlined"
            size="small"
            className={`UI-page-size-select ${isMobile ? 'UI-page-size-select-mobile' : ''} ${this.state.hovered === 'pagesize' ? 'UI-page-size-select-hover' : ''}`}
            onMouseEnter={() => this.setState({ hovered: 'pagesize' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            <MenuItem value={5}>5 per page</MenuItem>
            <MenuItem value={10}>10 per page</MenuItem>
            <MenuItem value={20}>20 per page</MenuItem>
            <MenuItem value={50}>50 per page</MenuItem>
          </TextField>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === 1 ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'first' && !(currentPage === 1) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(1)}
            disabled={currentPage === 1}
            onMouseEnter={() => !(currentPage === 1) && this.setState({ hovered: 'first' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'First' : 'First'}
          </button>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === 1 ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'prev' && !(currentPage === 1) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            onMouseEnter={() => !(currentPage === 1) && this.setState({ hovered: 'prev' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'Prev' : 'Previous'}
          </button>

          <span className={`UI-pagination-info ${isMobile ? 'UI-pagination-info-mobile' : ''}`}>
            Page {currentPage} of {totalPages}
          </span>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === totalPages ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'next' && !(currentPage === totalPages) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            onMouseEnter={() => !(currentPage === totalPages) && this.setState({ hovered: 'next' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'Next' : 'Next'}
          </button>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === totalPages ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'last' && !(currentPage === totalPages) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
            onMouseEnter={() => !(currentPage === totalPages) && this.setState({ hovered: 'last' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'Last' : 'Last'}
          </button>
        </div>
      </div>
    );
  }

  renderTable() {
    const isMobile = this.state.isMobile;
    const currentPageData = this.getCurrentPageData();
    const currentData = this.getCurrentData();

    if (currentData.length === 0) {
      return (
        <div className={`UI-no-items-message ${isMobile ? 'UI-no-items-message-mobile' : ''}`}>
          {this.state.searchTerm ? 'No losses found matching your search' : 'No losses available'}
        </div>
      );
    }

    return (
      <>
        <div className={`UI-table-container ${isMobile ? 'UI-table-container-mobile' : ''}`}>
          <table className={`UI-table ${isMobile ? 'UI-table-mobile' : ''}`}>
            <thead className="UI-table-header">
              <tr>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'itemname' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('itemname')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Item Name
                    <this.SortIndicator columnKey="itemname" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'category' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('category')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Category
                    <this.SortIndicator columnKey="category" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'whname' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('whname')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Warehouse
                    <this.SortIndicator columnKey="whname" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                >
                  Batch
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'quantity' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('quantity')}
                  style={{ cursor: 'pointer', textAlign: 'right' }}
                >
                  <div className="UI-th-content" style={{ justifyContent: 'flex-end' }}>
                    Quantity
                    <this.SortIndicator columnKey="quantity" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'price' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('price')}
                  style={{ cursor: 'pointer', textAlign: 'right' }}
                >
                  <div className="UI-th-content" style={{ justifyContent: 'flex-end' }}>
                    Unit Price
                    <this.SortIndicator columnKey="price" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'totalloss' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('totalloss')}
                  style={{ cursor: 'pointer', textAlign: 'right' }}
                >
                  <div className="UI-th-content" style={{ justifyContent: 'flex-end' }}>
                    Total Loss
                    <this.SortIndicator columnKey="totalloss" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                >
                  Comment
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'createdAt' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('createdAt')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Date
                    <this.SortIndicator columnKey="createdAt" />
                  </div>
                </th>
                {inventoryid === '2' || inventoryid === '3' ? (
                  <th className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`} style={{ textAlign: 'center' }}>
                    Actions
                  </th>
                ) : null}
              </tr>
            </thead>

            <tbody>
              {currentPageData.map((item) => (
                <tr
                  key={item.id}
                  className={`UI-table-row ${isMobile ? 'UI-table-row-mobile' : ''} ${this.state.hoveredRow === item.id ? 'UI-table-row-hovered' : ''}`}
                  onMouseEnter={() => this.setState({ hoveredRow: item.id })}
                  onMouseLeave={() => {
                    this.setState({ hoveredRow: null, isActionHovered: null });
                  }}
                >
                  {/* ITEM NAME */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-item-name ${this.state.hoveredRow === item.id ? 'UI-item-name-hover' : ''}`}
                  >
                    {this.highlightSearchText(item.itemname, this.state.searchTerm)}
                  </td>

                  {/* CATEGORY */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                  >
                    {this.highlightSearchText(item.category, this.state.searchTerm)}
                  </td>

                  {/* WAREHOUSE */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                  >
                    {this.highlightSearchText(item.whname, this.state.searchTerm)}
                  </td>

                  {/* BATCH */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                  >
                    {this.highlightSearchText(item.batchid, this.state.searchTerm)}
                  </td>

                  {/* QUANTITY */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                    style={{ textAlign: 'right' }}
                  >
                    {this.highlightSearchText(item.quantity, this.state.searchTerm)}
                  </td>

                  {/* UNIT PRICE */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                    style={{ textAlign: 'right' }}
                  >
                    <NumericFormat
                      displayType="text"
                      value={item.price}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      thousandSeparator={true}
                      thousandsGroupStyle={thousandsdisplay}
                    />
                  </td>

                  {/* TOTAL LOSS */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-amount ${this.state.hoveredRow === item.id ? 'UI-price-hover' : ''}`}
                    style={{ textAlign: "right" }}
                  >
                    <NumericFormat
                      displayType="text"
                      value={item.totalloss}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      thousandSeparator={true}
                      thousandsGroupStyle={thousandsdisplay}
                    />
                  </td>

                  {/* COMMENT */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                  >
                    {this.highlightSearchText(item.comment, this.state.searchTerm)}
                  </td>

                  {/* DATE */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                  >
                    {moment(item.createdAt).format("DD-MM-YYYY")}
                  </td>

                  {/* ACTION BUTTONS */}
                  {inventoryid === '2' || inventoryid === '3' ? (
                    <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                      <div className="UI-action-buttons">
                        {item.status === "Pending" && (
                          <>
                            {/* Edit Button */}
                            <Link
                              to={{ pathname: "/addlosses" }}
                              state={{ id: item.id, pagename: "Damage" }}
                              className={`UI-action-button ${isMobile ? 'UI-action-button-mobile' : ''} UI-edit-button`}
                              style={{ textDecoration: "none" }}
                              onClick={(e) => e.stopPropagation()}
                              onMouseEnter={() =>
                                this.setState({ isActionHovered: `edit-${item.id}` })
                              }
                              onMouseLeave={() => this.setState({ isActionHovered: null })}
                            >
                              <Tooltip title="Edit Loss" arrow slotProps={{
                                popper: {
                                  sx: { pointerEvents: 'none' },
                                },
                              }}>
                                <img
                                  src={EditIcon}
                                  alt="Edit"
                                  className={`UI-action-icon ${isMobile ? 'UI-action-icon-mobile' : ''} ${this.state.isActionHovered === `edit-${item.id}` ? 'UI-edit-icon-hover' : ''}`}
                                />
                              </Tooltip>
                            </Link>

                            {/* Approve Button */}
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                this.Approve(item.id);
                              }}
                              className={`UI-action-button ${isMobile ? 'UI-action-button-mobile' : ''} UI-approve-button`}
                              onMouseEnter={() =>
                                this.setState({ isActionHovered: `approve-${item.id}` })
                              }
                              onMouseLeave={() => this.setState({ isActionHovered: null })}
                            >
                              <Tooltip title="Approve Loss" arrow slotProps={{
                                popper: {
                                  sx: { pointerEvents: 'none' },
                                },
                              }}>
                                <img
                                  src={CheckIcon}
                                  alt="Approve"
                                  className={`UI-action-icon ${isMobile ? 'UI-action-icon-mobile' : ''} ${this.state.isActionHovered === `approve-${item.id}` ? 'UI-check-icon-hover' : ''}`}
                                />
                              </Tooltip>
                            </button>
                          </>
                        )}

                        {/* Show status if not Pending */}
                        {item.status !== "Pending" && (
                          <span className={`UI-status-badge ${item.status === 'Approved' ? 'UI-status-approved' : 'UI-status-completed'}`}>
                            {item.status}
                          </span>
                        )}
                      </div>
                    </td>
                  ) : null}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {this.renderPagination()}
      </>
    );
  }

  render() {
    const isMobile = this.state.isMobile;

    return (
      <div>
        <Header />
        <Menu />
        <div className="content-wrapper">
          <div className={`UI-container ${isMobile ? 'UI-container-mobile' : ''}`}>
            <div className="UI-card">
              {/* Header */}
              <div className={`UI-header ${isMobile ? 'UI-header-mobile' : ''}`}>
                <nav className={`UI-breadcrumb ${isMobile ? 'UI-breadcrumb-mobile' : ''}`}>
                  <Link
                    to="/inventory"
                    className={`UI-breadcrumb-item ${this.state.hovered === 'home' ? 'UI-breadcrumb-item-hover' : ''}`}
                    onMouseEnter={() => this.setState({ hovered: 'home' })}
                    onMouseLeave={() => this.setState({ hovered: null })}
                  >
                    Home
                  </Link>
                  <span>/</span>
                  <span className="UI-breadcrumb-item UI-breadcrumb-active">
                    Losses
                  </span>
                </nav>

                <div className={`UI-header-content ${isMobile ? 'UI-header-content-mobile' : ''}`}>
                  <div>
                    <h1 className={`UI-title ${isMobile ? 'UI-title-mobile' : ''}`}>
                      Losses
                    </h1>
                    <p className={`UI-subtitle ${isMobile ? 'UI-subtitle-mobile' : ''}`}>
                      Manage Damage/Loss records
                    </p>
                  </div>

                  <div className={`UI-header-actions ${isMobile ? 'UI-header-actions-mobile' : ''}`}>
                    {/* Success Message */}
                    {this.state.message && (
                      <div className="text-center text-success text-uppercase mb-2">
                        {this.state.message}
                      </div>
                    )}

                    {/* Mobile Search */}
                    {isMobile && (
                      <input
                        type="text"
                        placeholder="Search losses..."
                        value={this.state.searchTerm}
                        onChange={(e) => this.handleSearch(e.target.value)}
                        className="UI-mobile-search-input"
                      />
                    )}

                    <div className={`UI-buttons-row ${isMobile ? 'UI-buttons-row-mobile' : ''}`}>
                      {/* Desktop Search Toggle */}
                      {!isMobile && (
                        <div
                          className={`UI-search-container ${this.state.showSearch ? 'UI-search-container-expanded' : ''} ${this.state.hovered === "search" ? 'UI-search-container-hover' : ''}`}
                          onClick={() => {
                            if (!this.state.showSearch) this.setState({ showSearch: true });
                          }}
                          onMouseEnter={() => this.setState({ hovered: "search" })}
                          onMouseLeave={() => this.setState({ hovered: null })}
                        >
                          <i
                            className="fa fa-search UI-search-icon"
                          />
                          {!this.state.showSearch && "Search"}
                          {this.state.showSearch && (
                            <input
                              type="text"
                              placeholder="Search losses..."
                              value={this.state.searchTerm}
                              onChange={(e) => this.handleSearch(e.target.value)}
                              className="UI-search-input"
                              autoFocus
                              onClick={(e) => e.stopPropagation()}
                              onBlur={() => {
                                if (this.state.searchTerm.trim() === "") {
                                  this.setState({ showSearch: false });
                                }
                              }}
                            />
                          )}
                        </div>
                      )}

                      {/* New Loss button */}
                      {inventoryid === '2' || inventoryid === '3' ? (
                        <Link
                          to="/addlosses"
                          state={{ id: -1, pagename: "Damage" }}
                          className={`UI-btn UI-btn-primary ${this.state.hovered === "new" ? 'UI-btn-primary-hover' : ''} ${isMobile ? 'UI-btn-mobile' : ''}`}
                          onMouseEnter={() => this.setState({ hovered: "new" })}
                          onMouseLeave={() => this.setState({ hovered: null })}
                        >
                          <i className="fa fa-plus" /> {isMobile ? "New" : "New Loss"}
                        </Link>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>

              {this.state.loading ? (
                <div className="UI-loading-container">
                  {spin}
                </div>
              ) : (
                <>
                  {this.renderTabs()}
                  <div style={{ marginTop: '16px' }}>
                    {this.renderTable()}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withRouter(DamageTable);